var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-strip action"},[_c('img',{attrs:{"src":require("../assets/flag.svg"),"alt":"Flag","height":"56","width":"56"}}),_c('span',{staticClass:"text"},[_vm._v("Actions")])])
}]

export { render, staticRenderFns }